<template>
    <div class="Orario">
        <div class="pageContent">
            <TopLogoBar logoColor="white" textColor="#fff" title="Orario natalizio" />
            <div class="fullscreen-bg-orario"></div>
            <div class="container">
                <div class="columns">
                    <div class="column is-8 is-offset-2 orarioInfo has-text-justified">
                        <p><span style="font-weight: 500">In occasione delle festività natalizie e di fine anno,
                                gli uffici chiuderanno nei giorni:
                                <ul style="    list-style: disc;
    margin: 0 0 0 45px;
    padding: 10px;">
                                    <li><span class="redText">Giovedì 24 Dicembre</span></li>
                                    <li><span class="redText">Giovedì 31 Dicembre</span></li>
                                </ul>
                                <br></span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TopLogoBar from '@/components/TopLogoBar'

    import Snowflakes from 'magic-snowflakes'

    export default {
        name: 'Orario',
        props: [],
        components: {
            TopLogoBar
        },
        data() {
            return {
                snowObj: null
            }
        },
        mounted() {
            this.snowObj = Snowflakes({
                color: '#ca0000', //A8C2EC
                container: document.querySelector('.fullscreen-bg-orario'),
                maxSize: 50
            })
        },
        beforeDestroy() {
            this.snowObj.destroy()
        }
    }
</script>

<style scoped lang="scss">
    .Orario {
        width: 100%;

        .fullscreen-bg-orario {
            position: absolute;
            top: 0;
            height: 100%;
            width: 100%;
            z-index: -1;
            background: #000;

            @media only screen and (max-width: 768px) {
                background-position-x: 72%;
            }

        }

        .redText
        {
            color: #eb222b;
        }

        .pageContent {
            width: 100%;
            min-height: 100vh;
            overflow: hidden;
            position: relative;
            color: #fff;


            .orarioInfo {
                font-size: 28px;
                margin-top: 100px;
                padding: 30px;

                @media only screen and (max-width: 768px) {
                    margin-top: 20px;
                    font-size: 24px;
                }
            }

        }
    }
</style>